import { AlertOptions, useAppAlert } from '@/app/AppAlertProvider'
import DocumentPreviewNew from '@/app/common/components/Documents/DocumentPreviewNew'
import { AppRoutePaths } from '@/routing/route_paths'
import { RootState } from '@/storage/store'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { usePostRelationshipDocument } from './hooks/usePostRelationshipDocument'
import { usePostSpecialEducationDocument } from './hooks/usePostSpecialEducationDocument'
import useStudenDetailsDocumentParams from './hooks/useStudentDetailsDocumentParams'
import { useWizardContext } from './StudentDetailsWizardProvider'

export const DocumentReviewPage = () => {
  const { t: translate } = useTranslation()

  const { info } = useStudenDetailsDocumentParams()
  const navigateTo = useNavigate()
  const { fireAlert } = useAppAlert()
  const { formData } = useWizardContext()
  const { selectedStudentId, data: familyApplicationData } = useSelector(
    (state: RootState) => state.FamilyApplication
  )
  const { student_details } = AppRoutePaths.family_application
  const isRelationship = window.location.pathname.includes('relationship')
  const specialEducationMutation = usePostSpecialEducationDocument()
  const relationshipMutation = usePostRelationshipDocument()
  const handleSubmitError = (error: any) => {
    const alertConfig: AlertOptions = {
      variant: 'error',
      message:
        error.message ||
        translate('an_error_occurred_whil_processing_the_document'),
      denyBtn: true,
      denyBtnText: 'Retry',
    }

    fireAlert(alertConfig).then(({ denied }) => {
      if (denied) {
        navigateTo(-1)
      }
    })
  }

  const onSubmit = async () => {
    if (!formData.DateOfBirthFile) {
      return
    }
    const form = new FormData()
    form.append('file', formData.DateOfBirthFile)
    form.append(`requestFiles[]`, formData.DateOfBirthFile)
    form.append('document_type', String(info().id))
    form.append('student_id', String(selectedStudentId))
    form.append('application_id', String(familyApplicationData!.application_id))
    if (isRelationship) {
      relationshipMutation.mutate(form, {
        onSuccess: () => {
          navigateTo(student_details.relationship.document_submitted)
        },
        onError: ({ message }) => {
          handleSubmitError({ message })
        },
      })
    } else {
      specialEducationMutation.mutate(form, {
        onSuccess: () => {
          navigateTo(student_details.special_education.document_submitted)
        },
        onError: ({ message }) => {
          handleSubmitError({ message })
        },
      })
    }
  }

  return (
    <>
      <div className="text-3xl text-center font-medium text-gray-900 mb-10 sm:mb-5">
        {translate('photo_review')}
      </div>

      <div className="flex justify-center flex-col">
        <DocumentPreviewNew
          file={formData.DateOfBirthFile}
          onContinueClick={onSubmit}
          onRetakeClick={() => navigateTo(-1)}
          status={relationshipMutation.status}
        />
      </div>
    </>
  )
}
